<ttl-side-menu
  show-menu="true"
  side-menu-state="collapsed"
  side-menu-hover="false"
>
</ttl-side-menu>
